"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.omnidex = void 0;
exports.omnidex = {
    router: '0xF9678db1CE83f6f51E5df348E2Cc842Ca51EfEc1',
    zenmaster: '0x79f5A8BD0d6a00A41EA62cdA426CEf0115117a61',
};
